export interface PromotionInstance {
    adData: {},
    adType: string,
    from: string,
    id: number,
    location: number,
    multiple: boolean,
    pcm: string,
    resourceType: number,
    type: number
}

export interface BaiduUnionPromotionInstance extends PromotionInstance {
    adData: { id: string },
    adType: 'BAIDUUNION',
    type: 23,
}

export interface XPSPromotionInstance extends PromotionInstance {
    adType: 'XPS',
    adData: {
        maxTurn: number,
        lc: number,
        itemspaceid: string,
        adps: string,
        position: number,
        turn: number,
        maxreads: number,
    },
    type: 23,
}

/**
 * Determine is an object a PromotionInstance type.
 * @param  {any} obj
 * @returns objisPromotionInstance
 */
export const isPromotionInstance = (obj: any): obj is PromotionInstance => {
    if (typeof obj === 'object' && obj.adType) {
        return true;
    }
    return false;
};

/**
 * Determine is an object a BaiduUnionPromotionInstance type.
 * @param  {any} obj
 * @returns objisBaiduUnionPromotionInstance
 */
export const isBaiduUnionPromotionInstance = (obj: any): obj is BaiduUnionPromotionInstance => {
    if (isPromotionInstance(obj) && obj.adType === 'BAIDUUNION') {
        return true;
    }
    return false;
};

export const isXPSPromotionInstance = (obj:any): obj is XPSPromotionInstance => {
    if (isPromotionInstance(obj) && obj.adType === 'XPS') {
        return true;
    }
    return false;
};



// WEBPACK FOOTER //
// ./src/models/apis/promotion.ts